import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { useBusiness } from "@/features/business/hooks/businessQueries";
import { useBusinessLocation } from "@/features/business/hooks/businessLocationQueries";

export function useDashboardContext() {
  const { user } = useAuth();
  const { businessId = "", locationId = "" } = useParams();
  const business = useBusiness(businessId);
  const location = useBusinessLocation(locationId);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const update = () => setNow(new Date());
    const timer = window.setInterval(update, 15_000);
    window.addEventListener("focus", update);
    document.addEventListener("visibilitychange", update);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", update);
      document.removeEventListener("visibilitychange", update);
    };
  }, []);

  return { user, businessId, locationId, business, location, now };
}
